import { IControlProps, IPartialFormGroup } from '../types';
import FormControl from '../FormControl';
import Checkbox, { ICheckboxProps } from '../../atoms/Checkbox';
import { useHookFormController } from '../../hooks/useHookFormController';

export type ICheckboxControlProps = ICheckboxProps &
    Omit<IControlProps, 'defaultValue'> & {
        formGroupProps?: IPartialFormGroup;
    };

const CheckboxControl = ({
    name,
    rules,
    defaultChecked,
    control,
    shouldUnregister,
    formGroupProps,
    hideErrorMessage = true,
    ...props
}: ICheckboxControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultChecked}
            render={({ field }) => (
                <FormControl
                    readonlyAppearance={props.readOnly || props.disabled ? 'hint' : undefined}
                    name={name}
                    control={control}
                    {...formGroupProps}
                    hideErrorMessage={hideErrorMessage}
                >
                    <Checkbox
                        {...props}
                        checked={!!field.value}
                        onChange={(e) => {
                            field.onChange(e.currentTarget.checked);
                            props?.onChange?.(e);
                        }}
                        ref={field.ref}
                    />
                </FormControl>
            )}
        />
    );
};

export default CheckboxControl;
